export const isoToFullTime = (isoString: string) => {
  return new Date(isoString).toLocaleString('ru', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

export const isoToLocale = (isoString: string) => {
  return new Date(isoString).toLocaleString('ru', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  })
}

export const isoToLocaleString = (isoString: string) => {
  return new Date(isoString).toLocaleString('ru', {
    day: '2-digit',
    month: 'long'
  })
}

export const isoToTime = (isoString: string) => {
  return new Date(isoString).toLocaleString('ru', {
    hour: '2-digit',
    minute: '2-digit'
  })
}

export const isoToDateWithTime = (isoString: string) => {
  return new Date(isoString).toLocaleString('ru', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

export const isoToTimeWithSeconds = (isoString: string) => {
  return new Date(isoString).toLocaleString('ru', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  })
}

export const isoToMonthDay = (isoString: string) => {
  return new Date(isoString).toLocaleString('ru', {
    day: 'numeric',
    month: 'long'
  })
}
